import React from 'react';
import type { FC } from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import type { ChipProps } from './Chip.types';

export const Chip: FC<ChipProps> = props => {
  const { label, onClick, isSelected, isDisabled } = props;

  return (
    <Flex
      as="button"
      aria-label={label}
      paddingX={7}
      paddingY={3}
      justifyContent="center"
      alignItems="center"
      borderRadius={pxToRem(200)}
      backgroundColor={isSelected ? 'mono2' : 'transparent'}
      onClick={onClick}
      disabled={isDisabled}
      _disabled={{
        cursor: 'not-allowed',
        opacity: 0.7,
      }}
    >
      <TextV2
        typographyVariant="body3"
        color="mono14"
      >
        {label}
      </TextV2>
    </Flex>
  );
};
